export const getInitials = (words: string) => {
  return words
    .split(' ')
    .map((word) => word.substring(0, 1).toUpperCase())
    .slice(0, 2)
    .join('');
};
